var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { width: "30%", visible: _vm.checkedMealTimeBoxState },
      on: {
        "update:visible": function ($event) {
          _vm.checkedMealTimeBoxState = $event
        },
      },
    },
    [
      _c("add-product-dialog", {
        ref: "addProductDialog",
        attrs: {
          resourceObj: _vm.resourceObj,
          productObj: _vm.productObj,
          chenckBudgteObj: _vm.chenckBudgteObj,
          keyStr: _vm.keyStr,
        },
        on: { closeDialog: _vm.closeDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }